import axios, {AxiosInstance, AxiosRequestConfig} from "axios";
import {cfg} from "../config";

const {wp, request_timeout} = cfg
const {routes, qargs} = wp

// rest endpoint: /search
const XNAMESPACE = wp.custom
const WP_NAMESPACE = wp.namespace
const PER_PAGE = `per_page=${wp.posts_per_page}`

/**
 * @deprecated Not used in this project
 * Extend [Axios] to create our own custom Axios instance that can be easily reused
 *
 * IMPORTANT: Link below explains how to EXTEND [Axios] and thus use super() constructor to pass custom properties;
 *  however, this eliminates ALL BASIC features of Axios instance (as created by axios.create()) and complicates things.
 *  Therefore, since NO advantage to '... extends Axios', we just set private [AxiosInstance] in class and initialize
 *  it in constructor. From there, we can easily share a single instance of [WpClient] via React Context API and
 *  have same benefits of using extension w/o the hassle of reconfiguring everything abouto Axios.
 *
 * @source
 *  - https://stackoverflow.com/questions/37217716/using-es6-class-to-extend-axios#answer-65514631
 */
export class WpClient {
    _axios: AxiosInstance;

    constructor(config?: AxiosRequestConfig) {
        this._axios = axios.create({
            ...config,
            timeout: request_timeout,
            auth: {
                username: wp.api_user, // WordPress API user
                password: wp.api_pwd // WordPress app password
            }
        })
    }

    /**
     *
     * @param url
     * @param ignoreCache
     * @param symbol '?' or '&'
     */
    cacheWrapper(url: string, ignoreCache: boolean = false, symbol: string = '?') {
        let cacheSuffix = "";
        if (ignoreCache)
            cacheSuffix = `${symbol}${qargs.timestamp}=${Date.now()}`;
        return `${url}${cacheSuffix}`;
    }

    async doSomething(ignoreCache: boolean = false): Promise<any> {
        const url = this.cacheWrapper(`/${wp.routes.do_something}`, ignoreCache);
        const res = await this._axios.get(url);
        return res.data;
    }

}

type PropsCaching = {
    ignoreCache?: boolean
}